export default __webpack_public_path__ + "static/media/myself.69a50331.jpg";